import { FC } from "react";
import { makeStyles } from "tss-react/mui";
import { MiIcon } from "@miplatform/components";
import {
  PRIORITY_SCHEDULER_TAB_LABELS,
  TYPOGRAPHY_VARIANTS,
} from "@miplatform/constants";
import { mdiCheck } from "@mdi/js";
import { Box, Typography } from "@mui/material";

const PRIORITY_SCHEDULER_WORK_ORDERS_SUFFIX = " Work Orders";

const getEmptyStateText = ({
  isNotReadyMode = false,
  selectedTabLabel,
}: UnassignedWorkOrdersEmptyStateProps) => {
  const tabLabel = isNotReadyMode
    ? PRIORITY_SCHEDULER_TAB_LABELS.NOT_READY
    : PRIORITY_SCHEDULER_TAB_LABELS.UNASSIGNED;

  if (selectedTabLabel) {
    const modeLabel = tabLabel.replace(
      PRIORITY_SCHEDULER_WORK_ORDERS_SUFFIX,
      ""
    );
    return `No ${modeLabel} ${selectedTabLabel}`;
  }

  return `No ${tabLabel}`;
};

export const UnassignedWorkOrdersEmptyState: FC<
  UnassignedWorkOrdersEmptyStateProps
> = ({ selectedTabLabel, isNotReadyMode = false }) => {
  const { classes, theme } = useStyles();
  const text = getEmptyStateText({
    selectedTabLabel,
    isNotReadyMode,
  });

  return (
    <Box className={classes.root}>
      <Box className={classes.iconContainer}>
        <MiIcon
          path={mdiCheck}
          color={theme.palette.grey.darkerAccent}
          size={1.2}
        />
      </Box>
      <Typography variant={TYPOGRAPHY_VARIANTS.HD4}>{text}</Typography>
    </Box>
  );
};

interface UnassignedWorkOrdersEmptyStateProps {
  selectedTabLabel?: string | null;
  isNotReadyMode?: boolean;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(2),
  },
  iconContainer: {
    width: 56,
    height: 56,
    borderRadius: "50%",
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));
